import { createFileRoute } from "@tanstack/react-router"
import { SubmissionDetailPage } from "@/admin"

// The submissions_ prefix un-nests this route from submissions.tsx (the
// queue is a page, not a layout); the URL stays
// /admin/submissions/$assignmentId
export const Route = createFileRoute(
  "/(user)/admin/submissions_/$assignmentId",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { assignmentId } = Route.useParams()

  return <SubmissionDetailPage assignmentId={assignmentId} />
}
